/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_FamilyGroupMemberRequest } from './billing_FamilyGroupMemberRequest';
export type billing_FamilyGroupRequest = {
    /**
     * BillingType (UNIFIED or SPLIT)
     */
    billing_type: billing_FamilyGroupRequest.billing_type;
    /**
     * ChildID for the primary child
     */
    child_id: string;
    /**
     * FamilyName identifier
     */
    family_name: string;
    /**
     * Members to create alongside the family group
     */
    members?: Array<billing_FamilyGroupMemberRequest>;
    unified_billing_city?: string;
    unified_billing_country?: string;
    unified_billing_email?: string;
    unified_billing_house_number?: string;
    /**
     * UnifiedBilling details (required when BillingType is UNIFIED)
     */
    unified_billing_name?: string;
    unified_billing_postal_code?: string;
    unified_billing_street?: string;
};
export namespace billing_FamilyGroupRequest {
    /**
     * BillingType (UNIFIED or SPLIT)
     */
    export enum billing_type {
        UNIFIED = 'UNIFIED',
        SPLIT = 'SPLIT',
    }
}

